import { timeline } from '@/mocks/articles';

export default function TimelineSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            生涯时间线
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            从青岛少年到中国传奇，一部跨越18年的足球史诗
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary-200 md:-translate-x-px"></div>
          <div className="flex flex-col gap-8">
            {timeline.map((item, index) => (
              <div
                key={item.year}
                className={`relative flex items-start gap-6 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex flex-1"></div>
                <div className="relative z-10 flex items-center justify-center w-8 h-8 rounded-full bg-primary-500 text-background-50 shrink-0">
                  <i className={`${item.icon} text-sm`}></i>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="inline-flex px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-bold whitespace-nowrap">
                      {item.year}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed ml-0 md:ml-1">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}